/**
 * Конфигурация приложения
 * Все магические числа и настройки собраны в одном месте
 */

// Ограничения на контент
export const LIMITS = {
  MAX_PHOTOS: 3,
  MAX_NOTES_LENGTH: null, // Unlimited
};

// ID администраторов
export const ADMIN_IDS = [
  8233007585, // ArtDmSv (owner)
  309257010,  // Elena P
  407390648,  // Vladimir R
  7878599815, // Igor U
  112754809,  // Alexandr K
  130287057,  // Evgenii O
  166652615,  // Nikolai K
];

// Роли пользователей
export const ROLES = {
  ADMIN: "admin",
  MANAGER: "manager",
};

// Виды (views) приложения
export const VIEWS = {
  HOME: "home",
  ADD: "add",
  EDIT: "edit",
  LIST: "list",
  HELP: "help",
};

// Статусы работы с клиентом
export const WORK_STATUS = {
  YES: "yes",
  NO: "no",
  UNKNOWN: "unknown",
};

// Настройки Telegram WebApp
export const TELEGRAM_CONFIG = {
  HEADER_COLOR: "bg_color",
  BACKGROUND_COLOR: {
    LIGHT: "#f9fafb",
    DARK: "#1a1a1a",
  },
};

// Дефолтное значение для пустого лида
export const DEFAULT_LEAD_TYPE = "Affiliate";
export const DEFAULT_TRAFFIC_SOURCE = "TG";
export const DEFAULT_EVENT = "AWA Bangkok 25";
